export const setScenes = "scenes/SET_SCENES";
export const createScene = "scenes/CREATE_SCENE";
